import { render, staticRenderFns } from "./clockDetail.vue?vue&type=template&id=2567b110&scoped=true"
import script from "./clockDetail.vue?vue&type=script&lang=js"
export * from "./clockDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2567b110",
  null
  
)

export default component.exports